"use client";

import { SafeHydrate } from "@/SafeHydrate";
import React from "react";
import { Calendar, Phone } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ReadyToScale() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="221510" id="ready-to-scale" className="bg-background text-foreground py-16 px-4 sm:px-6 lg:px-8 overflow-hidden">
      <div ref={ref} className={`relative mx-auto max-w-6xl overflow-hidden rounded-lg bg-gradient-to-br from-secondary to-chart-2 px-6 py-20 text-center shadow-xl sm:px-12 sm:py-24 transition-all duration-1000 ease-out transform ${isVisible ? "translate-y-0 opacity-100" : "translate-y-12 opacity-0"}`}>
        {}
        <div className="absolute inset-0 opacity-[0.15] pointer-events-none mix-blend-overlay">
          <svg className="h-full w-full" xmlns="http://www.w3.org/2000/svg">
            <defs>
              <pattern id="geometric-pattern" width="60" height="60" patternUnits="userSpaceOnUse">
                <path d="M30 0L60 30L30 60L0 30Z" fill="none" stroke="currentColor" strokeWidth="2" className="text-primary-foreground" />
                <path d="M30 15L45 30L30 45L15 30Z" fill="none" stroke="currentColor" strokeWidth="1" className="text-primary-foreground" />
              </pattern>
            </defs>
            <rect width="100%" height="100%" fill="url(#geometric-pattern)" />
          </svg>
        </div>

        <div className="relative z-10 mx-auto max-w-3xl">
          <h2 className="font-default text-4xl font-bold tracking-tight text-primary-foreground sm:text-5xl lg:text-6xl">
            Ready to Turn AI Into Outcomes?
          </h2>
          <p className="mt-6 text-lg leading-8 text-primary-foreground/90 font-sans max-w-2xl mx-auto">
            Join the SMBs already scaling their operations with our AI operating model. 
            Let's identify your high-value workflows and start automating today.
          </p>
          <div className="mt-10 flex flex-col items-center justify-center gap-4 sm:flex-row">
            <Button size="lg" className="w-full sm:w-auto bg-ring text-primary-foreground hover:bg-ring/90 shadow-md h-14 px-8 text-base font-semibold transition-colors duration-200" asChild>
              <Link to="/ConnectPage">
                <Phone className="mr-2 size-5" />
                Book a Consultation
              </Link>
            </Button>
            <Button size="lg" variant="outline" className="w-full sm:w-auto border-2 border-primary-foreground text-primary-foreground hover:bg-primary-foreground hover:text-secondary shadow-md bg-transparent h-14 px-8 text-base font-semibold transition-colors duration-200" asChild>
              <Link to="/AIReadinessPage">
                <SafeHydrate><Calendar className="mr-2 size-5" /></SafeHydrate>
                Free AI Readiness Check
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}